<mat-card *ngIf="form.form_type_id === 1 || form.form_type_id === 2" class="card mat-elevation-z0" style="overflow-x: hidden; border-bottom: 1px solid var(--primary); ">
    <mat-card-content>
        <div fxLayout="row">

            <div fxLayout="column" fxFlex="80">
                <div fxLayout="row" class="cardInfo" fxLayoutAlign="start center center">

                    <div fxLayout="column" fxFlex="85" class="infoSection">

                        <div fxLayout="row" fxLayoutAlign="start center" class="titleSection">{{form.title}}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" class="subTtitleSection">{{form.description}}</div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε από:</span>
                            <span class="infoDescription" fxFlex="35">{{form.createdByFirstName}} {{form.createdByLastName}}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε στις:</span>
                            <span class="infoDescription" fxFlex="35">{{form.date_created}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημοσιευμένη:</span>
                            <span class="infoDescription" fxFlex="35">{{form.isPublished ? 'ΝΑΙ' : 'OXI'}}</span>
                        </div>

                        <div *ngIf="form.form_type_id === 2" fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δραστηριότητα:</span>
                            <span class="infoDescription" fxFlex="35">{{form.activity_description}}</span>
                        </div>

<!--                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">-->
<!--                            <span class="infoHeader" fxFlex="45">Ορατότητα:</span>-->
<!--                            <span class="infoDescription" fxFlex="35"><a style="color: var(&#45;&#45;primary); text-decoration: underline" (click)="navigateToStudentList(form)">Λίστα μαθητών</a></span>-->
<!--                        </div>-->

<!--                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">-->
<!--                            <span class="infoHeader" fxFlex="45">Κωδικός 2 βήμάτων:</span>-->
<!--                            <span class="infoDescription" fxFlex="35">{{form.has_two_factor? 'ΝΑΙ' : 'OXI'}}</span>-->
<!--                        </div>-->

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Προθεσμία:</span>
                            <span class="infoDescription" fxFlex="35">{{form.has_deadline === 0 ? '-' : 'Έως '+form.deadline_date}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Αριθμός θέσεων:</span>
                            <span class="infoDescription" fxFlex="35">{{form.has_max_slots === 0 ? '-' : form.max_slots}}</span>
                        </div>

<!--                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">-->
<!--                            <span class="infoHeader" fxFlex="45">Αυτοματοποιημένες ενέργειες:</span>-->
<!--                            <span class="infoDescription" fxFlex="35">{{form.has_automation ? 'ΝΑΙ' : 'ΟΧΙ'}}</span>-->
<!--                        </div>-->



                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε από:</span>
                            <span *ngIf="form.modified_by_first_name" class="infoDescription" fxFlex="35">{{form.modified_by_first_name}} {{form.modified_by_last_name}}</span>
                            <span *ngIf="!form.modified_by_first_name" class="infoDescription" fxFlex="35">-</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε στις:</span>
                            <span class="infoDescription"
                                  fxFlex="35">{{form.date_modified ? form.date_modified : '-'}}</span>
                        </div>

                    </div>
                </div>
            </div>


            <!--              Action Button-->
            <div fxLayout="column" fxLayoutAlign="center center center" fxFlex="20">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button
                                style="color: white; border-radius: 50px; background:var(--primary); border:1px solid var(--primary); font-family: 'Century Gothic', sans-serif !important;">
                            Ενέργεια
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>

                        <button mat-icon-button>
                            <mat-icon style="vertical-align: middle;">
                                more_vert
                            </mat-icon>
                        </button>

                    </div>
                </div>

                <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item class="menuList" (click)="showConsentForm(form)">
                            <button mat-menu-item>
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προεπισκόπιση
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="editCustomForm(form)" [disabled]="form.isPublished">
                                <mat-icon class="icon">edit</mat-icon>&nbsp;Επεξεργασία
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="duplicate(form)">
                                <mat-icon class="icon">file_copy</mat-icon>&nbsp;Αντιγραφή
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="publish(form)">
                                <mat-icon class="icon">send</mat-icon>&nbsp;Δημοσίευση σε χρήστες
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList"  >
                            <button mat-menu-item [disabled]="form.isPublished" (click)="deleteForm(form)">
                                <mat-icon class="icon">delete</mat-icon>&nbsp;Διαγραφή
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-menu>
            </div>
        </div>
    </mat-card-content>
</mat-card>



<mat-card *ngIf="form.form_type_id === 3" class="card mat-elevation-z0" style="overflow-x: hidden; border-bottom: 1px solid var(--primary);">
    <mat-card-content>
        <div fxLayout="row">

            <div fxLayout="column" fxFlex="80">
                <div fxLayout="row" class="cardInfo" fxLayoutAlign="start center center">

                    <div fxLayout="column" fxFlex="85" class="infoSection">

                        <div fxLayout="row" fxLayoutAlign="start center" class="titleSection">{{form.title}}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" class="subTtitleSection">{{form.description}}</div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε από:</span>
                            <span class="infoDescription" fxFlex="35">{{form.createdByFirstName}} {{form.createdByLastName}}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε στις:</span>
                            <span class="infoDescription" fxFlex="35">{{form.date_created}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημοσιευμένη:</span>
                            <span class="infoDescription" fxFlex="35">{{form.isPublished ? 'ΝΑΙ' : 'OXI'}}</span>
                        </div>

<!--                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">-->
<!--                            <span class="infoHeader" fxFlex="45">Ορατότητα:</span>-->
<!--                            <span class="infoDescription" fxFlex="35"><a style="color: var(&#45;&#45;primary); text-decoration: underline" (click)="navigateToStudentList(form)">Λίστα μαθητών</a></span>-->
<!--                        </div>-->

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε από:</span>
                            <span *ngIf="form.firstName" class="infoDescription" fxFlex="35">{{form.firstName}} {{form.lastName}}</span>
                            <span *ngIf="!form.firstName" class="infoDescription" fxFlex="35">-</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε στις:</span>
                            <span class="infoDescription"
                                  fxFlex="35">{{form.date_modified ? form.date_modified : '-'}}</span>
                        </div>

                    </div>
                </div>
            </div>


            <!--              Action Button-->
            <div fxLayout="column" fxLayoutAlign="center center center" fxFlex="20">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button
                                style="color: white; border-radius: 50px; background:var(--primary); border:1px solid var(--primary); font-family: 'Century Gothic', sans-serif !important;">
                            Ενέργεια
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>

                        <button mat-icon-button>
                            <mat-icon style="vertical-align: middle;">
                                more_vert
                            </mat-icon>
                        </button>

                    </div>
                </div>

                <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item class="menuList" (click)="showConsentForm(form)">
                            <button mat-menu-item>
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προεπισκοπηση
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button (click)="editAnnouncement(form)" [disabled]="form.isPublished" mat-menu-item>
                                <mat-icon class="icon">edit</mat-icon>&nbsp;Επεξεργασία
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item [disabled]="form.isPublished" (click)="deleteForm(form)">
                                <mat-icon class="icon">delete</mat-icon>&nbsp;Διαγραφή
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-menu>
            </div>
        </div>
    </mat-card-content>
</mat-card>


<mat-card *ngIf="form.form_type_id === 4" class="card mat-elevation-z0" style="overflow-x: hidden; border-bottom: 1px solid var(--primary);">
    <mat-card-content>
        <div fxLayout="row">

            <div fxLayout="column" fxFlex="80">
                <div fxLayout="row" class="cardInfo" fxLayoutAlign="start center center">

                    <div fxLayout="column" fxFlex="85" class="infoSection">

                        <div fxLayout="row" fxLayoutAlign="start center" class="titleSection">{{form.title}}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" class="subTtitleSection">{{form.description}}</div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε από:</span>
                            <span class="infoDescription" fxFlex="35">{{form.created_by_first_name}} {{form.created_by_last_name}}</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε στις:</span>
                            <span class="infoDescription" fxFlex="35">{{form.created_at}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημοσιευμένη:</span>
                            <span class="infoDescription" fxFlex="35">{{form.isPublished ? 'ΝΑΙ' : 'OXI'}}</span>
                        </div>

<!--                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">-->
<!--                            <span class="infoHeader" fxFlex="45">Ορατότητα:</span>-->
<!--                            <span class="infoDescription" fxFlex="35"><a style="color: var(&#45;&#45;primary); text-decoration: underline" (click)="navigateToStudentList(form)">Λίστα μαθητών</a></span>-->
<!--                        </div>-->

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε από:</span>
                            <span *ngIf="form.modified_by_first_name" class="infoDescription" fxFlex="35">{{form.modified_by_first_name}} {{form.modified_by_last_name}}</span>
                            <span *ngIf="!form.modified_by_first_name" class="infoDescription" fxFlex="35">-</span>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ενημερώθηκε στις:</span>
                            <span class="infoDescription"
                                  fxFlex="35">{{form.date_modified ? form.date_modified : '-'}}</span>
                        </div>

                    </div>
                </div>
            </div>


            <!--              Action Button-->
            <div fxLayout="column" fxLayoutAlign="center center center" fxFlex="20">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button
                                style="color: white; border-radius: 50px; background:var(--primary); border:1px solid var(--primary); font-family: 'Century Gothic', sans-serif !important;">
                            Ενέργεια
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>

                        <button mat-icon-button>
                            <mat-icon style="vertical-align: middle;">
                                more_vert
                            </mat-icon>
                        </button>

                    </div>
                </div>

                <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item class="menuList" (click)="showCustomForm(form)">
                            <button mat-menu-item>
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προεπισκοπηση
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button (click)="editCustomForm(form)" [disabled]="form.isPublished" mat-menu-item>
                                <mat-icon class="icon">edit</mat-icon>&nbsp;Επεξεργασία
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item [disabled]="form.isPublished" (click)="deleteForm(form)">
                                <mat-icon class="icon">delete</mat-icon>&nbsp;Διαγραφή
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-menu>
            </div>
        </div>
    </mat-card-content>
</mat-card>

